var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeuro2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19.272793 20.49",
    id: "svg18",
    width: 19.3,
    height: 20.5,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(-36.31,-3.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: "1.5px",
    fill: "none",
    stroke: "#000",
    d: "m 45.03,6.8 c 1.29,-0.02 2.3,0.24 2.92,0.46 0.76,0.26 2.85,1 3.75,2.73 0.26,0.5 0.5,1.23 0.62,1.6 0.24,0.73 0.33,1.15 0.42,1.48 0.19,0.67 0.63,1.6 1.71,2.65 0.05,0.04 0.34,0.27 0.38,0.68 0.04,0.5 -0.35,0.82 -0.38,0.84 -0.52,0.08 -1.04,0.16 -1.56,0.24 -0.09,0.69 -0.18,1.39 -0.26,2.08 -0.13,1.02 -0.97,1.78 -1.95,1.78 h -1.47 v 2.05 h -8.52 v -3.22 c 0,-0.31 -0.11,-0.62 -0.3,-0.86 -0.72,-0.9 -1.11,-1.65 -1.33,-2.34 -0.25,-0.79 -0.31,-1.51 -0.34,-2.48 -0.01,-0.44 0,-0.8 0.02,-1.06 m 4.52,-1.06 c -1.13,0 -2.05,0.88 -2.05,1.97 0,1.09 0.92,1.97 2.05,1.97 v 0 c 0,0 0,0 0,0 v 0 c 0,1.31 0.01,2.61 0.02,3.92 h 2.19 c 0,-1.51 -0.01,-3.02 -0.02,-4.53 0.13,0 0.34,-0.02 0.57,-0.13 0.36,-0.17 0.55,-0.46 0.61,-0.57 h 1.4 c 1.13,0 2.05,-0.88 2.05,-1.97 0,-0.8 -0.49,-1.5 -1.24,-1.8 C 48.35,10.67 47.62,10.35 46.83,10.42 46.45,10 45.9,9.76 45.3,9.76 M 38.61,7.6 H 38.04 C 37.61,7.6 37.26,7.25 37.26,6.82 V 6.25 c 0,-0.43 0.35,-0.78 0.78,-0.78 h 0.57 c 0.43,0 0.78,0.35 0.78,0.78 v 0.57 c 0,0.43 -0.35,0.78 -0.78,0.78 z m 3.71,2.84 h -0.57 c -0.43,0 -0.78,-0.35 -0.78,-0.78 V 9.09 c 0,-0.43 0.35,-0.78 0.78,-0.78 h 0.57 c 0.43,0 0.78,0.35 0.78,0.78 v 0.57 c 0,0.43 -0.35,0.78 -0.78,0.78 z m 0.24,-3.91 h -0.57 c -0.43,0 -0.78,-0.35 -0.78,-0.78 V 5.18 c 0,-0.43 0.35,-0.78 0.78,-0.78 h 0.57 c 0.43,0 0.78,0.35 0.78,0.78 v 0.57 c 0,0.43 -0.35,0.78 -0.78,0.78 z m -4.15,4.98 h -0.57 c -0.43,0 -0.78,-0.35 -0.78,-0.78 v -0.57 c 0,-0.43 0.35,-0.78 0.78,-0.78 h 0.57 c 0.43,0 0.78,0.35 0.78,0.78 v 0.57 c 0,0.43 -0.35,0.78 -0.78,0.78 z",
    id: "path10"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeuro2);
export default __webpack_public_path__ + "static/media/Neuro-2.4c7836d37ec624d9fcf81118f1733183.svg";
export { ForwardRef as ReactComponent };